import React from "react";
import AppRoutes from "routes";
import useAppLoad from "common/hooks/useAppLoad";
import { useAuth } from "common/context/auth";

const SplashPage = React.lazy(() => import("pages/splash"));
const LoginPage = React.lazy(() => import("pages/login"));

export default function App() {
  const { isLoaded, progress } = useAppLoad();
  const { appkey, authkey } = useAuth();

  // Initial splash (existing behaviour)
  if (!isLoaded) {
    return <SplashPage progress={progress} />;
  }

  // No keys yet → show login screen
  if (!appkey || !authkey) {
    return <LoginPage />;
  }

  // Keys present → show WhatsApp UI (current chat routes)
  return <AppRoutes />;
}
